export enum Bathroom {
    UNKNOWN = 0,
    COMBINED = 1,
    PARTED = 2,
    SEVERAL = 3
}
